import { useState, useEffect } from "react";

import { useSetup } from "../../Setup.context";
import { IBenefitsPolicy, BenefitsPolicyType } from "../../Setup.types";

import { Container, RadioCard, Row, SelectForm } from "./BenefitsPolicy.styled";

import { BenefitsPolicyRegion } from "./BenefitsPolicy.Region";
import { BenefitsPolicyRole } from "./BenefitsPolicy.Role";
import { Button, MenuItem } from "@mui/material";
import { BenefitsPolicyUnique } from "./BenefitsPolicy.Unique";
import { BenefitsPolicyCustom } from "./BenefitsPolicy.Custom";

export function BenefitsPolicy() {
  /** Values needed to change the global state */
  const { setup, updateSetup } = useSetup();

  /** Estado local que possui todos os campos de regra de contrato. */
  const [benefitsPolicy, setBenefitsPolicy] = useState<IBenefitsPolicy>(setup.benefitsPolicy);

  // Sync customDocument from context when:
  // 1. Local state has no document yet (async load completed after mount)
  // 2. Context has server data (documentId) but local state still has the pre-save file selection (no documentId)
  useEffect(() => {
    const contextDoc = setup.benefitsPolicy.customDocument;
    const localDoc = benefitsPolicy.customDocument;
    if (contextDoc && (!localDoc || (contextDoc.documentId && !localDoc.documentId))) {
      setBenefitsPolicy(prev => ({ ...prev, customDocument: contextDoc }));
    }
  }, [setup.benefitsPolicy.customDocument]);

  /** Função responsável por validar e salvar as edições feitas nos campos de políticas de benefício. */
  async function handleSave() {
    try {
      //validar...
      updateSetup({ ...setup, benefitsPolicy: benefitsPolicy });
    } catch (error) {
      console.error(error);
    }
  }

  /** Função responsável por editar os campos de políticas de benefício. */
  async function handleChangeRoles(payload: Partial<IBenefitsPolicy>) {
    const updatedBenefitsPolicyFields = { ...benefitsPolicy, ...payload };

    setBenefitsPolicy(updatedBenefitsPolicyFields);
  }

  return (
    <>
      <Container>
        {/* <SelectForm
          label="Selecione Categoria"
          value={benefitsPolicy.type || "ROLE"}
          onChange={(event) => handleChangeRoles({ type: event.target.value as BenefitsPolicyType })}
        >
          <MenuItem value="UNIQUE">Único</MenuItem>
          <MenuItem value="ROLE">Cargo/Função</MenuItem>
          <MenuItem value="GEOGRAPHIC_REGION">Região Geográfica</MenuItem>
        </SelectForm> */}
        <Row>
          <RadioCard
            label="Plano único"
            selected={benefitsPolicy.type === "UNIQUE"}
            onClick={() => handleChangeRoles({ type: "UNIQUE" })}
          />
          <RadioCard
            label="Cargo"
            selected={benefitsPolicy.type === "ROLE"}
            onClick={() => handleChangeRoles({ type: "ROLE" })}
          />
          <RadioCard
            label="Região geográfica"
            selected={benefitsPolicy.type === "GEOGRAPHIC_REGION"}
            onClick={() => handleChangeRoles({ type: "GEOGRAPHIC_REGION" })}
          />
          <RadioCard
            label="Personalizado"
            selected={benefitsPolicy.type === "CUSTOM"}
            onClick={() => handleChangeRoles({ type: "CUSTOM" })}
          />
        </Row>
        {benefitsPolicy.type === "ROLE" && <BenefitsPolicyRole benefitsPolicy={benefitsPolicy} handleChange={handleChangeRoles} />}
        {benefitsPolicy.type === "UNIQUE" && <BenefitsPolicyUnique benefitsPolicy={benefitsPolicy} handleChange={handleChangeRoles} />}
        {benefitsPolicy.type === "GEOGRAPHIC_REGION" && <BenefitsPolicyRegion benefitsPolicy={benefitsPolicy} handleChange={handleChangeRoles} />}
        {benefitsPolicy.type === "CUSTOM" && <BenefitsPolicyCustom benefitsPolicy={benefitsPolicy} handleChange={handleChangeRoles} />}
      </Container>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: "8px",
          marginTop: "50px",
        }}
      >
        <Button
            variant="contained"
            style={{
              paddingTop: "0.25rem",
              paddingBottom: "0.25rem",
              paddingLeft: "1rem",
              paddingRight: "1rem",
              borderRadius: "0.375rem",
              height: "2.5rem",
              fontSize: "0.875rem",
              lineHeight: "1.25rem",
              fontWeight: 600,
              width: "130px",
              marginLeft: "50px"
            }}
            onClick={handleSave}
          >
            {"Salvar"}
          </Button>
      </div>
    </>
  );
}
